/* eslint-disable import/no-duplicates */
/* eslint-disable no-lonely-if */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-useless-escape */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useLayoutEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { produce } from "immer";
// context
import StepperContext from "../../components/molecules/Stepper/StepperContext";
import LoaderContext from "../../components/molecules/Loader/LoaderContext";
// configs
import routes from "../../../application/config/routes";
// models
import personalDataUiModel from "./uiModel";
// components
import PersonalDataTemplate from "../../components/templates/PersonalDataTemplate/PersonalDataTemplate";
// actions
import { personalDataActions } from "../../../application/actions/personalData";
import { executiveActions } from "../../../application/actions/executive";
import { identityActions } from "../../../application/actions/identity";
// utils
import { isArray } from "../../../domain/utils/utilitarios-frontend-coopeuch/array";
import { insertStringAfterBeforeCharOrString } from "../../../domain/utils/utilitarios-frontend-coopeuch/text";

import { isMobile } from "../../utils/platform";
import {
  saveAllEntitiesToStorage,
  saveAllEntitiesFromStorage,
} from "../../utils/storage";
import {
  formatRut,
  RutFormat,
} from "../../../domain/utils/utilitarios-frontend-coopeuch/rut";
import { getAlphanumericRandomString } from "../../../domain/utils/utilitarios-frontend-coopeuch/text";
import sendAnalitycs from "../../../domain/utils/utilitarios-frontend-coopeuch/Analytics";
import dataLayerObject from "../../../domain/utils/dataLayerObject";
import { genPayloadToRegisterPersonalData } from "./payload";
import { coverageActions } from "../../../application/actions/coverage/index";

import { useModal } from "../../hooks/useModal";
import edgeCases from "../../localData/edgeCases";
import sendAnalytics from "../../../domain/utils/utilitarios-frontend-coopeuch/Analytics";

// constants
const safesignerState = getAlphanumericRandomString(12);
const safesignerNonce = getAlphanumericRandomString(12);
const isDeviceMobile = isMobile();


// Auxiliar para useEffect validatePersonalData
 /* istanbul ignore next */
const handleValidationSuccess = (validatePersonalData, setIsValidPerson, setCountryNationality, stateMap, professionItems) => {
  sendAnalitycs(dataLayerObject.PERSONAL_DATA_VERIFIED_CEDULE);
  setIsValidPerson(true);
  
  if (String(validatePersonalData.person.nationality).toUpperCase() === "E") {
    const nextStateCountryNationality = produce((draft) => {
      draft.isVisible = true;
    });
    setCountryNationality(nextStateCountryNationality);
  }
  
  sessionStorage.setItem("token", validatePersonalData.token);
   /* istanbul ignore next */
  for (const [key, value] of Object.entries(validatePersonalData.person)) {
    if (key !== "profession" && key !== "nationality") {
      const nextStateItemValidatePersonalData = produce((draft) => {
        draft.value = value;
      });
      stateMap[key].seter(nextStateItemValidatePersonalData);
    }
  }
   /* istanbul ignore next */
  const professionFiltered = professionItems?.filter(
    (el) => validatePersonalData.person.profession.toUpperCase() === el.valor.toUpperCase()
  )[0];
  
  if (professionFiltered) {
    const nextStateProfession = produce((draft) => {
      draft.value = { ...professionFiltered };
    });
    stateMap.profession.seter(nextStateProfession);
  }
};
 /* istanbul ignore next */
const handleValidationErrorCodes = (code, setCurrentEdgeCase, dispatch, setIsOpenModalAlreadyMemberRedirection, validatePersonalData) => {
  if (code === "12") {
    sessionStorage.setItem("token", validatePersonalData.message);
    setIsOpenModalAlreadyMemberRedirection(true);
    return;
  }
   /* istanbul ignore next */
  const errorActions = {
    "11": () => { setCurrentEdgeCase(edgeCases.recentFormerPartner); sendAnalitycs(dataLayerObject.BORDE_RECENT_FORMER_PARTNER); },
    "8": () => { setCurrentEdgeCase(edgeCases.underage); sendAnalitycs(dataLayerObject.BORDE_UNDERAGE); },
    "7": () => { setCurrentEdgeCase(edgeCases.legalPerson); sendAnalitycs(dataLayerObject.BORDE_LEGAL_PERSON); },
    "13": () => { setCurrentEdgeCase(edgeCases.fatca); },
    "71": () => { setCurrentEdgeCase(edgeCases.genericExitFlow); sendAnalitycs(dataLayerObject.BORDE_GENERIC_ERROR_EXIT_FLOW); },
    "-1": () => { setCurrentEdgeCase(edgeCases.restrictedHours); sendAnalitycs(dataLayerObject.BORDE_RESTRICTED_HOURS); },
    "85": () => { setCurrentEdgeCase(edgeCases.customerWithUnpaidFees); },
    "100": () => { setCurrentEdgeCase(edgeCases.hasAccount); sendAnalitycs(dataLayerObject.BORDE_ALREADY_MEMBER); },
    "101": () => { dispatch(personalDataActions.changeStateBadSerial({ stateSerial: true })); },
    "104": () => { setCurrentEdgeCase(edgeCases.limitHorario); }
  };
  
  if (errorActions[code]) {
    errorActions[code]();
  } else {
    setCurrentEdgeCase(edgeCases.generic);
  }
};

// Auxiliar para useEffect validateIdentity
 /* istanbul ignore next */
const handleIdentityErrorDetail = (errorDetail, setCurrentEdgeCase) => {
  const errorId = errorDetail.id;
  
  if (errorId === "3") {
    setCurrentEdgeCase(edgeCases.identityValidationAttemptsExceeded);
    sendAnalitycs(dataLayerObject.BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDEDD);
  } else if (errorId === "5" || errorId === "41") {
    setCurrentEdgeCase(edgeCases.identityValidationBlockingGenericError);
    sendAnalitycs(dataLayerObject.BORDE_IDENTITY_VALIDATION_OFFICE_REDIRECTION);
  } else if (errorId === "1") {
    setCurrentEdgeCase(edgeCases.identityValidationNotAvailable);
    sendAnalitycs(dataLayerObject.BORDE_IDENTITY_VALIDATION_NOT_AVAILABLE);
  } else if (errorId === "22") {
    setCurrentEdgeCase(edgeCases.identityValidationWrongAccount);
  } else if (errorId === "117") {
    setCurrentEdgeCase(edgeCases.identityFacialBiometryAttemptsExceeded);
  } else if (["79", "90", "113", "118", "119"].includes(errorId)) {
    setCurrentEdgeCase(edgeCases.identityFacialBiometryError);
    sendAnalitycs(dataLayerObject.BORDE_IDENTITY_FACIAL_BIOMETRY_ERROR);
  } else {
    if (errorDetail.blocker) {
      setCurrentEdgeCase(edgeCases.identityValidationNotAvailable);
    } else {
      setCurrentEdgeCase(edgeCases.identityValidationRetry);
    }
  }
};

// Auxiliar para handleChangeField - sanitización
 /* istanbul ignore next */
const sanitizeFieldValue = (field, value, stateMap) => {
  // Si no es string, devolver tal cual
  if (typeof value !== 'string') return value;
  
  if (["firstName", "lastName", "maternalLastName"].includes(field) && stateMap[field]?.state?.value.trim() === "") {
    return value.toUpperCase();
  }
  if (field === "address") return value.replace(/[^a-z0-9\s]/gi, "");
  if (field === "rut") return value.replace(/[^a-z0-9\-]/gi, "");
  if (field === "serialNumber") return value.replace(/[^a-z0-9]/gi, "");
  if (field === "email") return value.replace(/[^a-zA-Z0-9._+\-@]/g, "");
  return value;
};

// Maneja el caso especial de rehydrate de address
 /* istanbul ignore next */
const handleAddressRehydrate = (value, dispatch, isRehydratingAddressRef) => {
  isRehydratingAddressRef.current = true;
  if (value?.street && value?.numeration && value?.commune && value?.country) {
    const coveragePayload = {
      address: { ...value },
      type: "PAR",
      typeAddress: "homeAddress",
    };
    dispatch(coverageActions.fetchCoverage(Object.freeze(coveragePayload)));
  }
};

// Maneja el caso de workActivity
 /* istanbul ignore next */
const handleWorkActivityChange = (value, setPosition) => {
  const nextState = produce((draft) => {
    draft.isVisible = value.id === "01";
  });
  setPosition(nextState);
};

// Maneja el caso de executiveAttending
 /* istanbul ignore next */
const handleExecutiveAttendingChange = (value, executiveCode, stateMap) => {
  if (value === "NO" && executiveCode.value !== "") {
    const nextExecutiveCode = produce((draft) => {
      draft.value = "";
    });
    stateMap.executiveCode.seter(nextExecutiveCode);
  }
};

// Maneja el caso de scheduling
 /* istanbul ignore next */
const handleSchedulingChange = (value, stateMap, setScheduling) => {
  const updatedScheduling = {
    ...stateMap.scheduling.state.value,
    ...value,
  };

  const setearScheduling = {
    communeId: updatedScheduling.communeId,
    day: updatedScheduling.day,
    hour: updatedScheduling.hour,
    regionId: updatedScheduling.regionId,
    latitude: updatedScheduling.latitude,
    longitude: updatedScheduling.longitude,
    moduleId: updatedScheduling.moduleId,
  };

  stateMap.scheduling.seter(setearScheduling);
  setScheduling(setearScheduling);
};

// Actualiza el estado del campo
 /* istanbul ignore next */
const updateFieldState = (field, property, finalValue, errorsList, stateMap, extra) => {
  if (!stateMap[field]) return;

  const nextState = produce((draft) => {
    if (isArray(stateMap[field]?.state)) {
      draft[extra?.index][property] = finalValue;
      draft[extra?.index].errors = errorsList;
    } else {
      draft[property] = finalValue;
      draft.errors = errorsList;
    }
  });
  stateMap[field].seter(nextState);
};

// Limpia errores del campo complementario
 /* istanbul ignore next */
const clearComplementErrors = (field, stateMap) => {
  if (
    stateMap[field]?.state?.complement &&
    stateMap[stateMap[field]?.state?.complement]?.state?.errors.length > 0
  ) {
    const nextStateField = produce((draft) => {
      draft.errors = [];
    });
    stateMap[stateMap[field]?.state?.complement]?.seter(nextStateField);
  }
};
 /* istanbul ignore next */
const PersonalDataContainer = () => {
  const isRehydratingAddressRef = useRef(false);
  const [rut, setRut] = useState({ ...personalDataUiModel.rut });
  const [serialNumber, setSerialNumber] = useState({
    ...personalDataUiModel.serialNumber,
  });
  const [firstName, setFirstName] = useState({
    ...personalDataUiModel.firstName,
  });
  const [lastName, setLastName] = useState({ ...personalDataUiModel.lastName });
  const [optionsDays, setOptionsDays] = useState([]);
  const [maternalLastName, setMaternalLastName] = useState({
    ...personalDataUiModel.maternalLastName,
  });
  const [profession, setProfession] = useState({
    ...personalDataUiModel.profession,
  });
  const [position, setPosition] = useState({ ...personalDataUiModel.position });
  const [workActivity, setWorkActivity] = useState({
    ...personalDataUiModel.workActivity,
  });
  const [countryNationality, setCountryNationality] = useState({
    ...personalDataUiModel.countryNationality,
  });
  const [phone, setPhone] = useState({ ...personalDataUiModel.phone });
  const [confirmationPhone, setConfirmationPhone] = useState({
    ...personalDataUiModel.confirmationPhone,
  });
  const [email, setEmail] = useState({ ...personalDataUiModel.email });
  const [address, setAddress] = useState({ ...personalDataUiModel.address });
  const [newAddress, setNewAddress] = useState({
    ...personalDataUiModel.newAddress,
  });
  const [taxDeclaration, setTaxDeclaration] = useState({
    ...personalDataUiModel.taxDeclaration,
  });
  const [preferredOffice, setPreferredOffice] = useState({
    ...personalDataUiModel.preferredOffice,
  });
  const [isValidPerson, setIsValidPerson] = useState(false);
  const [previredAuthorization, setPreviredAuthorization] = useState({
    ...personalDataUiModel.previredAuthorization,
  });
  const [isValidStep, setIsValidStep] = useState(false);
  const [isCompletedCardPersonValidation, setIsCompletedCardPersonValidation] = useState(false);
  const [isCompletedCardPersonalData, setIsCompletedCardPersonalData] = useState(false);
  const [isCompletedCardContactData, setIsCompletedCardContactData] = useState(false);
  const [isCompletedCardPreferredOffice, setIsCompletedCardPreferredOffice] = useState(false);
  const [isCompletedCardDeclarationsData, setIsCompletedCardDeclarationsData] = useState(false);
  const [isVisiblePreferredOffice, setIsVisiblePreferredOffice] = useState(false);
  const [isCompletedCardDirectionData, setIsCompletedCardDirectionData] = useState(false);
  const [selectedOptionRadio, setSelectedOptionRadio] = useState(() => {
    return sessionStorage.getItem("option-tarjeta") || "domicilio";
  });

  const [scheduling, setScheduling] = useState({
    ...personalDataUiModel.schedule,
  });

  const [showIsRequiredPreviredAuthorization, setShowIsRequiredPreviredAuthorization] = useState(false);
  const [currentEdgeCase, setCurrentEdgeCase] = useState({
    title: "",
  });
  const [officesItems, setOfficesItems] = useState([]);
  const [executiveCode, setExecutiveCode] = useState({
    ...personalDataUiModel.executiveCode,
  });
  const [executiveAttending, setExecutiveAttending] = useState({
    ...personalDataUiModel.executiveAttending,
  });
  const [isValidExecutiveCode, setIsValidExecutiveCode] = useState("optional");

  const appRoutes = routes();
  const history = useHistory();
  const dispatch = useDispatch();

  const professionItems = useSelector(
    (store) => store.entities.profession.professions
  );
  const positionItems = useSelector(
    (store) => store.entities.position.position
  );
  const workActivityItems = useSelector(
    (store) => store.entities.workActivity.workActivity
  );
  const countryNationalityItems = useSelector(
    (store) => store.entities.countryNationality.countryNationality
  );
  const indicators = useSelector((store) => store.entities.indicators);
  const regionsWithOfficesItems = useSelector(
    (store) => store.entities.offices.offices
  );

  const validatePersonalData = useSelector(
    (store) => store.entities.personalData?.validatePersonalData
  );
  const isLoadingFetchExecutive = useSelector(
    (store) => store.ui?.loaders?.isLoadingFetchExecutive
  );
  const executive = useSelector((store) => store.entities.executive);
  const isLoadingValidatePersonalData = useSelector(
    (store) => store.ui.loaders.isLoadingValidatePersonalData
  );
  const registerPersonalData = useSelector(
    (store) => store.entities.personalData?.registerPersonalData
  );
  const isLoadingRegisterPersonalData = useSelector(
    (store) => store.ui.loaders.isLoadingRegisterPersonalData
  );
  const isLoadingFetchCoverage = useSelector(
    (store) => store.ui.loaders.isLoadingFetchCoverage
  );
  const validateIdentity = useSelector(
    (store) => store.entities?.identity?.validateIdentity
  );
  const isLoadingValidateIdentity = useSelector(
    (store) => store.ui.loaders.isLoadingValidateIdentity
  );

  const coverage = useSelector((store) => store.entities.coverage);

  const [isOpenModalEdgeCase, openModalEdgeCase, closeModalEdgeCase] = useModal(false);
  const [isOpenModalAlreadyMemberRedirection, setIsOpenModalAlreadyMemberRedirection] = useModal(false);
  const [isOpenModalAbandonmentSurvey, setIsOpenModalAbandonmentSurvey, closeModalAbandonmentSurvey] = useModal(false);

  const { handleChangeStep } = useContext(StepperContext);
  const { handleChangeLoading } = useContext(LoaderContext);

  const tempRedirectUrl = `${window.location.origin}${window.location.pathname}`;
  const redirectUrl = tempRedirectUrl.endsWith("/") 
  ? tempRedirectUrl.slice(0, -1) 
  : tempRedirectUrl;

  const redirectSafesigner = `${process.env.REACT_APP_SAFESIGNER_INTEGRATION_URL}?c=${process.env.REACT_APP_SAFESIGNER_C}&client_id=${process.env.REACT_APP_SAFESIGNER_CLIENT_ID}&scope=${process.env.REACT_APP_SAFESIGNER_SCOPE}&redirect_uri=${redirectUrl}&state=${safesignerState}&nonce=${safesignerNonce}&error_redirect=true&rut=${rut.value}&e=${email.value}&identity_doc=${serialNumber.value}`;
   /* istanbul ignore next */
  const stateFields = (dataType) => {
    const fields = {
      rut,
      serialNumber,
      firstName,
      lastName,
      maternalLastName,
      profession,
      position,
      workActivity,
      countryNationality,
      phone,
      confirmationPhone,
      email,
      address,
      taxDeclaration,
      previredAuthorization,
      executiveCode,
      executiveAttending,
      preferredOffice,
      genPayloadToRegisterPersonalData,
      scheduling,
    };
    return dataType === "array" ? Object.values(fields) : { ...fields };
  };

  const queryParams = new URLSearchParams(history.location.search);
  const state = queryParams.get("state") || "";
  /* istanbul ignore next */
  const stateMap = {
    rut: { state: rut, seter: setRut },
    serialNumber: { state: serialNumber, seter: setSerialNumber },
    firstName: { state: firstName, seter: setFirstName },
    lastName: { state: lastName, seter: setLastName },
    maternalLastName: { state: maternalLastName, seter: setMaternalLastName },
    profession: { state: profession, seter: setProfession },
    position: { state: position, seter: setPosition },
    workActivity: { state: workActivity, seter: setWorkActivity },
    countryNationality: {
      state: countryNationality,
      seter: setCountryNationality,
    },
    phone: { state: phone, seter: setPhone },
    confirmationPhone: {
      state: confirmationPhone,
      seter: setConfirmationPhone,
    },
    email: { state: email, seter: setEmail },
    address: { state: address, seter: setAddress },
    taxDeclaration: { state: taxDeclaration, seter: setTaxDeclaration },
    previredAuthorization: {
      state: previredAuthorization,
      seter: setPreviredAuthorization,
    },
    executiveCode: {
      state: executiveCode,
      seter: setExecutiveCode,
    },
    executiveAttending: {
      state: executiveAttending,
      seter: setExecutiveAttending,
    },
    preferredOffice: {
      state: preferredOffice,
      seter: setPreferredOffice,
    },
    scheduling: {
      state: scheduling.value,
      seter: setScheduling,
    },
  };
   /* istanbul ignore next */
  const entitiesInCard = {
    CardPersonValidation: [rut, serialNumber, previredAuthorization],
    CardPersonalData: [
      firstName,
      lastName,
      maternalLastName,
      profession,
      workActivity,
      position,
      countryNationality,
    ],
    CardContactData: [email, phone, confirmationPhone, address],
    CardDirectionData: [scheduling],
    CardPreferredOffice: [preferredOffice, executiveAttending],
    CardDeclarationsData: [taxDeclaration],
  };
   /* istanbul ignore next */
  const getCompletedCard = (cardName) => {
    return (
      entitiesInCard[cardName]
        .filter((el) => el.isVisible)
        .map((el) => el.isValid(el.value) && el.errors.length === 0)
        .every((val) => val === true)
    );
  };
   /* istanbul ignore next */
  useLayoutEffect(() => {
    if (sessionStorage.getItem("correctStep") || state !== "") {
      if (
        String(sessionStorage.getItem("correctStep")) === "1" ||
        state !== ""
      ) {
        const queryParams = new URLSearchParams(history.location.search);
        if (history.location.search !== "") {
          const code = queryParams.get("code") || "";
          const error = queryParams.get("error") || "";
          const errorDescription = queryParams.get("error_description") || "";
          const payloadIdentityValidation = { code, error, errorDescription };
          if (state === sessionStorage.getItem("safesigner-state")) {
            handleChangeLoading(true);
            sessionStorage.setItem("safesigner-state", "");
            dispatch(
              identityActions.validateIdentity(payloadIdentityValidation)
            );
          } else {
            console.log("CASO BORDE NO CONTROLADO: los state no coinciden");
          }
        } else {
          console.log(
            "CASO BORDE NO CONTROLADO: TIENE EL PASO, no hay queryparams, se borraron los parametros en la url y se regrescó, o no corresponde el previouspath - ERROR NO CONTROLADO"
          );
        }
      } else if (String(sessionStorage.getItem("correctStep")) === "2") {
        history.push(appRoutes.contracts.path, { from: "/datos-personales" });
      } else {
        sendAnalitycs(dataLayerObject.PERSONAL_DATA_LOADED);
        sessionStorage.setItem("correctStep", String(1));
      }
    } else {
      sessionStorage.setItem("correctStep", String(1));
      sendAnalitycs(dataLayerObject.PERSONAL_DATA_LOADED);
      handleChangeStep(1);
    }
  }, [state]);
   /* istanbul ignore next */
  useEffect(() => {
    const registeredPersonalData =
      sessionStorage.getItem("registered-person-data") || "";
    if (currentEdgeCase.blocker === false && registeredPersonalData === "OK") {
      const valuesFromStorageToSave = saveAllEntitiesFromStorage(
        stateFields("object"),
        ["profession", "workActivity", "countryNationality", "position"]
      );
      
      valuesFromStorageToSave.forEach((entity) => {
        const nextState = produce((draft) => {
          draft.value = entity.value;
        });

        if (stateMap[entity.key]) {
          stateMap[entity.key].seter(nextState);
        } else {
          console.error(
            `Clave inesperada o inexistente en stateMap: ${entity.key}`
          );
        }
      });
      const nextStateCountryNationality = produce((draft) => {
        draft.isVisible =
          sessionStorage.getItem("country-nationality-visivility") === "true";
      });
      setCountryNationality(nextStateCountryNationality);
      setIsValidPerson(true);
    }
  }, [currentEdgeCase]);
  /* istanbul ignore next */
  useEffect(() => {
    if (
      executive.successFetching &&
      executive.executive &&
      executive.executive.code !== ""
    ) {
      setIsValidExecutiveCode("valid");
      sendAnalitycs(dataLayerObject.PERSONAL_DATA_EXECUTIVE_CODE, [
        {
          key: "eve-lab",
          param: "codigo-ejecutivo",
          value: executive.executive.codigo,
        },
      ]);
    }

    if (executive.errorFetching) {
      setIsValidExecutiveCode("invalid");
    }
  }, [executive]);
  /* istanbul ignore next */
  useEffect(() => {
    if (indicators.successFetching === true && indicators.indicators.length) {
      const ufObject = indicators.indicators.filter(
        (el) => el.tipo.toUpperCase() === "UF"
      )[0];
      sessionStorage.setItem("uf-value", ufObject.valor);
      sessionStorage.setItem("uf-date", ufObject.fecha);
    }
  }, [indicators]);
   /* istanbul ignore next */
  useEffect(() => {
    handleChangeLoading(isLoadingFetchCoverage);
  }, [isLoadingFetchCoverage]);
   /* istanbul ignore next */
  useEffect(
    () =>
      setIsCompletedCardPersonValidation(
        getCompletedCard("CardPersonValidation")
      ),
    [entitiesInCard.CardPersonValidation]
  );
   /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardPersonalData(getCompletedCard("CardPersonalData")),
    [entitiesInCard.CardPersonalData]
  );
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardContactData(getCompletedCard("CardContactData")),
    [entitiesInCard.CardContactData]
  );
  /* istanbul ignore next */
  useEffect(
    () => setIsCompletedCardDirectionData(getCompletedCard("CardDirectionData")),
    [entitiesInCard.CardDirectionData, scheduling?.hour]
  );
   /* istanbul ignore next */
  useEffect(
    () =>
      setIsCompletedCardPreferredOffice(
        getCompletedCard("CardPreferredOffice")
      ),
    [entitiesInCard.CardPreferredOffice]
  );
   /* istanbul ignore next */
  useEffect(
    () =>
      setIsCompletedCardDeclarationsData(
        getCompletedCard("CardDeclarationsData")
      ),
    [entitiesInCard.CardDeclarationsData]
  );
   /* istanbul ignore next */
  useEffect(() => {
    const isDeliveryValid = isCompletedCardDirectionData && 
    scheduling?.hour &&
    scheduling?.day; 
    const isOfficeValid = isCompletedCardPreferredOffice;
     /* istanbul ignore next */
    const canContinue =
      isCompletedCardPersonalData &&
      isCompletedCardPersonValidation &&
      isCompletedCardContactData &&
      isCompletedCardDeclarationsData &&
      ((selectedOptionRadio === "domicilio" && isDeliveryValid) ||
        (selectedOptionRadio === "sucursal" && isOfficeValid));

    setIsValidStep(canContinue);
  }, [
    isCompletedCardPersonalData,
    isCompletedCardPersonValidation,
    isCompletedCardContactData,
    isCompletedCardDirectionData,
    scheduling?.hour,
    scheduling?.day,
    isCompletedCardPreferredOffice,
    isCompletedCardDeclarationsData,
    selectedOptionRadio,
  ]);
   /* istanbul ignore next */
  useEffect(() => {
    if (dataLayerObject[currentEdgeCase.casesDataLayer])
      sendAnalitycs(dataLayerObject[currentEdgeCase.casesDataLayer]);
  }, [currentEdgeCase]);
   /* istanbul ignore next */
  useEffect(() => {
    if (!isOpenModalEdgeCase && currentEdgeCase.title !== "")
      setCurrentEdgeCase({ title: "" });
  }, [isOpenModalEdgeCase]);
   /* istanbul ignore next */
  useEffect(() => {
    if (validatePersonalData.success) {
      handleValidationSuccess(validatePersonalData, setIsValidPerson, setCountryNationality, stateMap, professionItems);
    } else if (validatePersonalData.error) {
      if (validatePersonalData.code !== "12") {
        openModalEdgeCase();
      }
      handleValidationErrorCodes(validatePersonalData.code, setCurrentEdgeCase, dispatch, setIsOpenModalAlreadyMemberRedirection, validatePersonalData);
    }
  }, [validatePersonalData]);
   /* istanbul ignore next */
  useEffect(() => {
    if (isLoadingRegisterPersonalData !== null) {
      if (!isLoadingRegisterPersonalData)
        setTimeout(
          () => handleChangeLoading(isLoadingRegisterPersonalData),
          100
        );
      else handleChangeLoading(isLoadingRegisterPersonalData);
    }
  }, [isLoadingRegisterPersonalData]);
   /* istanbul ignore next */
  useEffect(() => {
    if (isLoadingValidateIdentity !== null) {
      if (!isLoadingValidateIdentity)
        setTimeout(() => handleChangeLoading(isLoadingValidateIdentity), 100);
      else handleChangeLoading(isLoadingValidateIdentity);
    }
  }, [isLoadingValidateIdentity]);
   /* istanbul ignore next */
  useEffect(() => {
    if (registerPersonalData.success) {
      saveAllEntitiesToStorage(stateFields("object"));
      sessionStorage.setItem("registered-person-data", "OK");
      sessionStorage.setItem("another-data-address", address.anotherData);
      sessionStorage.setItem(
        "country-nationality-visivility",
        countryNationality.isVisible
      );
      sessionStorage.setItem("safesigner-state", safesignerState);
      window.location = redirectSafesigner;
    } else if (registerPersonalData.error) {
      openModalEdgeCase();
      if (registerPersonalData.code === "5") {
        setCurrentEdgeCase(edgeCases.fatca);
      } else if (
        registerPersonalData.code === "4" ||
        registerPersonalData.code === "9"
      ) {
        setCurrentEdgeCase(edgeCases.genericExitFlow);
      } else if (registerPersonalData.code === "41") {
        setCurrentEdgeCase(edgeCases.restrictionToForeigners);
      } else {
        setCurrentEdgeCase(edgeCases.generic);
      }
    }
  }, [registerPersonalData]);
   /* istanbul ignore next */
  useEffect(() => {
    if (validateIdentity.success) {
      sessionStorage.setItem("validateIdentitySuccess", "true");
      handleChangeLoading(false);
      if (validateIdentity.code === 200) {
        sessionStorage.setItem("correctStep", String(2));
        history.push(appRoutes.contracts.path, {
          from: history.location.pathname,
        });
      } else {
        openModalEdgeCase();
        handleIdentityErrorDetail(validateIdentity.errorDetail, setCurrentEdgeCase);
      }
    } else if (validateIdentity.error) {
      handleChangeLoading(false);
      openModalEdgeCase();
      const nextStateCountryNationality = produce((draft) => {
        draft.isVisible =
          sessionStorage.getItem("country-nationality-visivility") === "true";
      });
      setCountryNationality(nextStateCountryNationality);
      setIsValidPerson(true);
      setCurrentEdgeCase(edgeCases.identityValidationRetry);
    }
  }, [validateIdentity]);
   /* istanbul ignore next */
  useEffect(() => {
    if (taxDeclaration.value.usa) {
      sendAnalitycs(dataLayerObject.BORDE_DIFFERENT_CHILE_TAX_PAYMENT);
    }
  }, [taxDeclaration]);

  const handleRedirectToPublicSite = () => {
    window.location = appRoutes.landing.path;
  };

  const handleRedirectToPrivateSite = (caseAnalityc) => {
    if (dataLayerObject[caseAnalityc])
      sendAnalitycs(dataLayerObject[caseAnalityc]);
    window.location = appRoutes.privateSite.path;
  };

  const handleActionButtonCaseBorder = () => {
    if (currentEdgeCase.redirect === "privateSite")
      handleRedirectToPrivateSite(
        `${currentEdgeCase.casesDataLayer}_UNDERSTOOD`
      );
    else if (currentEdgeCase.redirect === "publicSite") {
      if (dataLayerObject[`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`])
        sendAnalitycs(
          dataLayerObject[`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`]
        );
      handleRedirectToPublicSite();
    } else closeModalEdgeCase();
  };

   /* istanbul ignore next */
  const handleChangeField = ({ field, property, value, extra }) => {
    // Caso especial: rehydrate de address
    if (field === "address" && property === "rehydrate") {
      handleAddressRehydrate(value, dispatch, isRehydratingAddressRef);
      return;
    }

    let finalValue;

    // Generar lista de errores
    const generateErrorsList = () => {
      const errors = [];
      const isValidValue = isArray(stateMap[field])
        ? stateMap[field][extra?.index]?.isValid?.(value, field)
        : stateMap[field]?.state?.isValid?.(value, field);

      if (!isValidValue) {
        errors.push({
          text: "El formato ingresado es incorrecto",
          type: "error",
        });
      } else if (
        stateMap[field]?.state?.complement &&
        stateMap[stateMap[field]?.state?.complement]?.state?.value !== "" &&
        value !== stateMap[stateMap[field]?.state?.complement]?.state?.value
      ) {
        if (field === "phone" || field === "confirmationPhone") {
          errors.push({
            text: "los teléfonos no coinciden",
            type: "error",
          });
        }
      }
      return errors;
    };

    const errorsList = property === "value" ? generateErrorsList() : [];

    // Casos especiales por campo
    if (field === "workActivity") {
      handleWorkActivityChange(value, setPosition);
    }

    // Sanitizar valor
    finalValue = sanitizeFieldValue(field, value, stateMap);

    // Caso especial: address con anotherData
    if (field === "address" && property === "anotherData") {
      finalValue = value.replace(/[^a-z0-9\s]/gi, "");
    }

    // Caso especial: executiveAttending
    if (field === "executiveAttending") {
      handleExecutiveAttendingChange(value, executiveCode, stateMap);
    }

    // Caso especial: scheduling
    if (field === "scheduling") {
      handleSchedulingChange(value, stateMap, setScheduling);
    }

    // Actualizar estado del campo
    updateFieldState(field, property, finalValue, errorsList, stateMap, extra);

    // Limpiar errores del campo complementario
    clearComplementErrors(field, stateMap);
  };
   /* istanbul ignore next */
  const handleValidatePerson = () => {
    sendAnalitycs(dataLayerObject.PERSONAL_DATA_CEDULE_VERIFICATION);
    if (isCompletedCardPersonValidation) {
      const payloadValidatePerson = {
        rut: formatRut(rut.value, RutFormat.DASH),
        numeroSerie: serialNumber.value,
      };
      dispatch(personalDataActions.validatePersonalData(payloadValidatePerson));
    } else if (!previredAuthorization.value) {
      setShowIsRequiredPreviredAuthorization(true);
    }
  };
   /* istanbul ignore next */
  const handleChangeRegion = async (regionSelected) => {
    setIsVisiblePreferredOffice(false);
    const nextPreferredOffice = produce((draft) => {
      draft.value = {
        ...personalDataUiModel.preferredOffice.value,
      };
    });
    stateMap.preferredOffice.seter(nextPreferredOffice);
    setOfficesItems(
      regionSelected.comunas
        .reduce(
          (prev, curr) => [
            ...prev,
            ...curr.sucursales.map((office) => {
              return {
                value: office.codigoOficina,
                label: office.sucursal,
                address: office.direccion,
                commune: curr.nombre,
                officeHours: office.horario,
                region: regionSelected.region,
              };
            }),
          ],
          []
        )
        .filter((el) => el)
    );
  };
   /* istanbul ignore next */
  const handleChangeOffice = (officeSelected) => {
    setIsVisiblePreferredOffice(true);
    sendAnalytics(dataLayerObject.PERSONAL_DATA_SELECTED_BRANCH, [
      {
        key: "eve-lab",
        param: "comuna",
        value: officeSelected.commune,
      },
    ]);
    const nextPreferredOffice = produce((draft) => {
      draft.value = {
        ...preferredOffice.value,
        id: officeSelected.value,
        name: officeSelected.label,
        commune: officeSelected.commune,
        region: officeSelected.region,
        address: officeSelected.address,
        officeHours: insertStringAfterBeforeCharOrString(
          officeSelected.officeHours,
          "<br />",
          "viernes",
          false
        ),
      };
    });
    stateMap.preferredOffice.seter(nextPreferredOffice);
  };
   /* istanbul ignore next */
  const handleChangeExecutiveCode = (code) => {
    const tempCode = code.replace(/[^a-zA-Z]/g, "");
    const nextExecutiveCode = produce((draft) => {
      draft.value = tempCode;
    });
    stateMap.executiveCode.seter(nextExecutiveCode);
    if (tempCode.length === 4) {
      const executivePayload = {
        executiveCode: tempCode,
      };
      dispatch(
        executiveActions.fetchExecutive(Object.freeze(executivePayload))
      );
    }
  };
   /* istanbul ignore next */
  const handleContinueFlow = () => {
    sendAnalitycs(dataLayerObject.PERSONAL_DATA_TO_STEP_2_BUTTON, [
      {
        key: "eve-lab",
        param: "texto-boton",
        value: "Continuar",
      },
    ]);

    sendAnalitycs(dataLayerObject.PERSONAL_DATA_TO_BIOMETRY);

    const personalDataToRegister = genPayloadToRegisterPersonalData(
      stateFields("object")
    );
    dispatch(personalDataActions.registerPersonalData(personalDataToRegister));
  };
  /* istanbul ignore next */
  const handleCancelFlow = () => {
    sendAnalitycs(dataLayerObject.PERSONAL_DATA_TO_STEP_2_BUTTON, [
      {
        key: "eve-lab",
        param: "texto-boton",
        value: "Cancelar",
      },
    ]);
    const token = sessionStorage.getItem("token");
    if (token) {
      setIsOpenModalAbandonmentSurvey(true);
      sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_LOAD, [
        {
          key: "page",
          param: "paso",
          value: window.location.pathname,
        },
      ]);
    } else window.location = appRoutes.landing.path;
  };
  /* istanbul ignore next */
  useEffect(() => {
    if (isRehydratingAddressRef.current) {
      isRehydratingAddressRef.current = false;
      return;
    }
    if (address.numeration || address.value.street || address.value.commune) {
      const coveragePayload = {
        address: { ...address.value },
        type: "PAR",
        typeAddress: "homeAddress",
      };
      dispatch(coverageActions.fetchCoverage(Object.freeze(coveragePayload)));
    }
  }, [
    address.value?.street,
    address.value?.numeration,
    address.value?.commune,
    address.value?.country]);
  /* istanbul ignore next */
  useEffect(() => {
    const v = address?.value || {};
    const complete = !!(v.street && v.numeration && v.commune && v.country);
    if (!complete) {
      setOptionsDays([]);
      dispatch(coverageActions.cleanCoverageStatus());
    }
  }, [
    address?.value?.street,
    address?.value?.numeration,
    address?.value?.commune,
    address?.value?.country,
  ]);
   /* istanbul ignore next */
  useEffect(() => {
    if (coverage.schedule) {
      const days = coverage?.schedule.map((day) => ({
        date: day.date,
        communeId: day.communeId,
        regionId: day.regionId,
        schedule: day.schedule,
      }));
      setOptionsDays(days);
    } else {
      setOptionsDays([]);
    }
  }, [coverage]);
   /* istanbul ignore next */
  const handleAddressChange = (type, property, value) => {
    if (type === "address") {
      setAddress((prev) => ({
        ...prev,
        value: {
          ...prev.value,
          [property]: value,
        },
        errors: address.isValid(address.value) ? [] : ["Invalid address"],
      }));
    } else if (type === "direction") {
      setNewAddress((prev) => ({
        ...prev,
        value: {
          ...prev.value,
          [property]: value,
        },
        errors: newAddress.isValid(newAddress.value)
          ? []
          : ["Invalid new address"],
      }));
      const addressPayload = {
        address: { ...property.value },
        type: "DES",
        typeAddress: "newAddress",
      };
      dispatch(coverageActions.fetchCoverage(Object.freeze(addressPayload)));
    }
  };
   /* istanbul ignore next */
  const handleSelectGetCard = (option) => {
    sessionStorage.setItem("option-tarjeta", option);
    setSelectedOptionRadio(option);
    sendAnalitycs(dataLayerObject.DELIVERY_RETIRO_OFFICE, [
      {
        key: "eve-lab",
        param: "despacho",
        value:
          option === "sucursal" ? "Retiro en Sucursal" : "Despacho a domicilio",
      },
    ]);
  };
  /* istanbul ignore next */
  return (
    <PersonalDataTemplate
      rut={rut}
      serialNumber={serialNumber}
      previredAuthorization={previredAuthorization}
      firstName={firstName}
      lastName={lastName}
      maternalLastName={maternalLastName}
      position={position}
      profession={profession}
      workActivity={workActivity}
      countryNationality={countryNationality}
      regionsWithOfficesItems={regionsWithOfficesItems}
      officesItems={officesItems}
      preferredOffice={preferredOffice}
      phone={phone}
      confirmationPhone={confirmationPhone}
      email={email}
      address={address}
      taxDeclaration={taxDeclaration}
      isValidPerson={isValidPerson}
      isMobileDevice={isDeviceMobile}
      professionItems={professionItems}
      positionItems={positionItems}
      workActivityItems={workActivityItems}
      countryNationalityItems={countryNationalityItems}
      executiveCode={executiveCode}
      executive={executive.executive || {}}
      executiveAttending={executiveAttending}
      isCompletedCardPersonValidation={isCompletedCardPersonValidation}
      isCompletedCardPersonalData={isCompletedCardPersonalData}
      isCompletedCardContacData={isCompletedCardContactData}
      isCompletedCardDirectionData={isCompletedCardDirectionData}
      isCompletedCardPreferredOffice={isCompletedCardPreferredOffice}
      isCompletedCardDeclarationsData={isCompletedCardDeclarationsData}
      isOpenModalAlreadyMemberRedirection={isOpenModalAlreadyMemberRedirection}
      isOpenModalAbandonmentSurvey={isOpenModalAbandonmentSurvey}
      canContinueFlow={isValidStep}
      isOpenModalEdgeCase={isOpenModalEdgeCase}
      closeModalEdgeCase={closeModalEdgeCase}
      closeModalAbandonmentSurvey={closeModalAbandonmentSurvey}
      showIsRequiredPreviredAuthorization={showIsRequiredPreviredAuthorization}
      currentEdgeCase={currentEdgeCase}
      isValidExecutiveCode={isValidExecutiveCode}
      isVisiblePreferredOffice={isVisiblePreferredOffice}
      isLoadingValidatePersonalData={isLoadingValidatePersonalData}
      isLoadingFetchExecutive={isLoadingFetchExecutive}
      onChangePreferences={handleChangeField}
      onChangeExecutiveCode={handleChangeExecutiveCode}
      onChangeRegion={handleChangeRegion}
      onChangeOffice={handleChangeOffice}
      onChangeUserData={handleChangeField}
      onValidatePerson={handleValidatePerson}
      onActionButtonCaseBorder={handleActionButtonCaseBorder}
      onContinueFlow={handleContinueFlow}
      onCancelFlow={handleCancelFlow}
      handleSelectGetCard={handleSelectGetCard}
      selectedOptionRadio={selectedOptionRadio}
      coverageData={coverage}
      optionsDays={optionsDays}
      onChangeAddress={handleAddressChange}
      newAddress={newAddress}
      scheduling={scheduling}
    />
  );
};

export default PersonalDataContainer;